// Client-side audit log — defansif. Edge Function da yazıyor; bu helper
// frontend-only eylemler için (voice_profile CRUD, audio.delete vs.).

import { supabase } from './supabase';

export interface AuditPayload {
  action: string;                       // 'voice.create', 'voice.update', 'audio.delete', 'user.create', ...
  target_type?: string;                 // 'voice_profile', 'admin_user', 'audio_history'
  target_id?: string;
  target_label?: string;
  metadata?: Record<string, unknown>;
}

export async function logAdminAction(p: AuditPayload): Promise<string | null> {
  const { data, error } = await supabase.rpc('log_admin_action', {
    p_action: p.action,
    p_target_type: p.target_type ?? null,
    p_target_id: p.target_id ?? null,
    p_target_label: p.target_label ?? null,
    p_metadata: p.metadata ?? {},
  });
  if (error) {
    if (import.meta.env.DEV) console.error('log_admin_action failed', error);
    return null;
  }
  return data as string;
}
